import { Translator } from '../../types/ApiResponseTypes'
import { CustomerLeaderboardRequest } from '@/types/customer/CustomerLeaderboardRequestType'

class CustomerLeaderboardRequestTranslator implements Translator<CustomerLeaderboardRequest> {
  convert(request: any): CustomerLeaderboardRequest {
    return {
      customerId: request.customerId == undefined ? '' : request.customerId,
      UsageType: request.usageType == undefined ? '' : request.usageType,
      UsageOrder: request.usageOrder == undefined ? '' : request.usageOrder,
    }
  }
}

export const isLeaderboardRequest = (request: any): request is CustomerLeaderboardRequest => {
  if (request === undefined) {
    return false
  }
  return 'customerId' in request && 'UsageType' in request && 'UsageOrder' in request
}

export default new CustomerLeaderboardRequestTranslator()
